import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthenticationContext } from '../auth/AuthenticationWrap';
import { UserRole } from '../../../constants/roles';

interface ProtectedRouteProps {
    children: React.ReactNode;
    allowedRoles: UserRole[];
    fallbackMessage?: string;
    fallbackTitle?: string;
}

export default function ProtectedRoute({ 
    children, 
    allowedRoles, 
    fallbackMessage = "This page is not accessible with your current role.",
    fallbackTitle = "Access Denied"
}: ProtectedRouteProps) {
    const authContext = useContext(AuthenticationContext);
    const { userInfo } = authContext || {};
    
    if (!userInfo || !userInfo.role || !allowedRoles.includes(userInfo.role)) {
        return (
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <h2>{fallbackTitle}</h2>
                <p>{fallbackMessage}</p>
            </div>
        );
    }

    return <>{children}</>;
}
